<template>
    <div class="loc-1">
        <div class="topFlex" v-if="setTitle != '查看'">
            <div class="topLeft">
                <el-button type="info" @click="clearArea"
                    >清空电子围栏区域</el-button
                >
            </div>
            <div class="topRight">
                <!-- <el-button type="primary" class="ml20" @click="oldFeet"
                    >轨迹</el-button
                > -->
                <el-button type="primary" class="ml20" @click="drawArea"
                    >绘制电子围栏区域</el-button
                >
            </div>
        </div>
        <div v-if="setTitle == '查看'" style="margin-bottom: 5px">
            <el-row :span="24">
                <el-col :span="14">
                    <span>时间：</span>
                    <el-date-picker
                        v-model="timerange"
                        type="datetimerange"
                        range-separator="至"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" @click="timeSure">确定</el-button>
                </el-col>
            </el-row>
        </div>
        <div id="container2" style="width: 100%; height: 700px">
            <!-- <div class="tabBox">
                <el-table
                    :data="tableData"
                    border
                    style="width: 100%"
                    :header-cell-style="{
                        background: '#f2f2f2',
                        color: '#000',
                    }"
                >
                    <el-table-column
                        type="index"
                        width="70"
                        label="序号"
                        align="center"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="createdTime"
                        label="时间"
                        align="center"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="durnTime"
                        label="告警时长"
                        align="center"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                </el-table>
            </div> -->
        </div>
    </div>
</template>

<script>
import exportVue from "@/utils/exportVue"
export default {
    props: {
        setTitle: {
            type: String,
            default: "",
        },
        formData: {},
        // gjInfo: {},
    },
    data() {
        return {
            tableData: [
                { createdTime: "2021-7-29 10:39:21 ", durnTime: "36分钟" },
                { createdTime: "2021-7-29 13:09:56 ", durnTime: "12分钟" },
            ],
            myMap: null,
            isMap: true,
            polygons: [],
            polygon: [],
            polygonArr: [],
            marker: null, //地图标记点
            markers: [],
            object3Dlayer: {},
            line3D: {},
            mouseTool: null,
            infoWindow: null,
            addForm: { pointPosition: "" },
            typeList: [
                { value: "1", label: "普通客户" },
                { value: "3", label: "残联服务对象" },
                { value: "4", label: "老干服务对象" },
                { value: "6", label: "政府援助客户" },
                { value: "7", label: "商业服务对象" },
                { value: "8", label: "D类援助客户" },
                { value: "10", label: "文明办服务对象" },
                { value: "13", label: "军人事务局服务对象" },
            ],
            watchLongitude: "",
            watchLatitude: "",
            records: [],
            endTime: "",
            startTime: "",
            timerange: "",
        }
    },

    watch: {
        formData: {
            async handler(val) {
                if (val.watchLongitude && val.watchLatitude && val.records) {
                    this.watchLongitude = val.watchLongitude
                    this.watchLatitude = val.watchLatitude
                }
                this.getPolygon().then((res) => {
                    this.polygon =
                        val.pointPosition == null || val.pointPosition == ""
                            ? []
                            : val.pointPosition.split(",")
                    //  console.log(this.polygon, "轨迹", val.pointPosition)
                })
            },

            deep: true,
            immediate: true,
        },
    },
    created() {
        exportVue.$on("records", (data) => {
            this.records = []
            if (data.length > 0) {
                this.records = data
                this.getLines()
            } else {
                this.myMap.remove(this.object3Dlayer)
                this.myMap.remove(this.marker)
            }
        })
    },
    mounted() {
        this.inti()
    },
    methods: {
        timeSure() {
            //  this.myMap.remove(this.object3Dlayer)
            // this.myMap.remove(this.marker)
            const self = this;
    try {
        // 移除3D图层
        if (self.object3Dlayer) {
            self.myMap.remove(self.object3Dlayer);
            self.object3Dlayer = null;
            self.myMap.remove(self.marker)
            self.marker=null
        }
            // 清除line3D对象引用
            self.line3D = null;
        } catch (err) {
          //  console.log(err);
        }
            exportVue.$emit("timerange", this.timerange)
        },
        wUpdata() {
            this.$emit("getGjInfo", this.addForm)
        },
        async inti() {
            await this.loadMap().then((res) => {
                // if (this.formData.id) {
                // this.getPont()
                this.getPolygon()
                //this.getLines()
                this.potintMaps()

                // }
            })
        },
        // 轨迹
        oldFeet() {
            this.getLines()
        },
        // 绘制电子围栏区域
        drawArea() {
            const that = this
            if (this.polygon.length > 0) {
                return this.$message.warning("请先删除已有区域")
            }
            this.mouseTool.close(true)
            this.mouseTool.polygon()
            this.drawFun()
        },
        drawFun() {
            const that = this
            this.mouseTool = new AMap.MouseTool(this.myMap)
            this.mouseTool.on("draw", function (e) {
                //监听draw事件可获取画好的覆盖物
                that.polygonArr = []
                e.obj.getPath().forEach((element) => {
                    that.polygonArr.push([element.lng, element.lat])
                })
                let s = []
                that.polygonArr.forEach((e) => {
                    s.push(`${e[0]}:${e[1]}`)
                })

                that.addForm.pointPosition = s.join()
                that.wUpdata()
            })
            this.mouseTool.polygon({
                fillColor: "#00b0ff",
                strokeColor: "#80d8ff",
                //同Polygon的Option设置
            })
        },

        // 重置区域
        clearArea() {
            const that = this
            this.polygon = []
            this.myMap.clearMap()
            this.myMap.remove(this.mouseTool)
            // this.mouseTool.close(true)
            this.mouseTool = new AMap.MouseTool(this.myMap)
            this.mouseTool.close(true) // 关闭，并清除覆盖物
            // this.mouseTool.polygon()
            this.getPolygon()
            this.getLines()
            // this.getPont()
        },

        // 打点
        potintMaps() {
            const self = this
            if (this.watchLongitude && this.watchLatitude) {
                try {
                    self.myMap.remove(self.marker)
                } catch (err) {}
                self.marker = new AMap.Marker({
                    icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                    position: [
                        Number(this.watchLongitude),
                        Number(this.watchLatitude),
                    ],
                })
                self.myMap.add(self.marker)
                self.myMap.setFitView()
            }
        },
        // 打点
        getPont() {
            const self = this
            try {
                self.myMap.remove(self.marker)
            } catch (err) {
                console.log(err)
            }

            self.marker = new AMap.Marker({
                icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                position: [
                    Number(self.formData.longitude),
                    Number(self.formData.latitude),
                ],
            })
            // let customerTypeName = ""
            // self.typeList.forEach((item) => {
            //     if (this.formData.customerType == item.value) {
            //         customerTypeName = item.label
            //     }
            // })
            // this.infoWindow = new AMap.InfoWindow({
            //     offset: new AMap.Pixel(0, -30),
            // })
            // self.marker.content = `
            //       <div style="background: #ffffff; padding: 12px;border-radius: 5px;opacity: 0.7;">
            //           <p>姓名：${formData.customerName}</p>
            //           <p>用户类型：${customerTypeName}</p>
            //           <p>联系电话：${formData.phone}</p>
            //           <p>地址：${formData.address}</p>
            //       </div>
            //   `

            // self.marker.marker.on("click", this.markerClick)
            // self.markers.push(marker)
            // this.infoWindow.open(this.myMap, e.target.getPosition())
            self.myMap.add(self.marker)
            self.myMap.setFitView()
        },
        markerClick(e) {
            this.infoWindow.setContent(e.target.content)
            this.infoWindow.open(this.myMap, e.target.getPosition())
        },
        // 初始化
        loadMap() {
            const that = this
            return new Promise((resolve, reject) => {
                this.myMap = new AMap.Map("container2", {
                    zoom: 12,
                    zooms: [3, 20],
                    pitch: 53,
                    defaultCursor: "default",
                    viewMode: "3D",
                    defaultCursor: "pointer",
                    showBuildingBlock: false,
                    expandZoomRange: true,
                    center: [117.179071, 31.817215],
                    // center: [that.formData.longitude, that.formData.latitude], //初始化地图中心点
                })
                this.mouseTool = new AMap.MouseTool(this.myMap)
                resolve()
            })
        },
        // 轨迹
        getLines() {
            let data = this.records
            const self = this
            self.potintMap(data[0].longitude, data[0].latitude)
            self.potintMap(data[data.length-1].longitude, data[data.length-1].latitude)
            // self.myMap.remove(self.object3Dlayer)
            try {
                self.myMap.remove(self.object3Dlayer)
            } catch (err) {
                console.log(err)
            }
            // alert(1)
            // console.log(data[0].longitude, data[0].latitude, "进来的轨迹")
            self.line3D = {}
            self.object3Dlayer = {}
            self.object3Dlayer = new AMap.Object3DLayer({ zIndex: 20 })

            self.myMap.add(self.object3Dlayer)

            self.line3D = new AMap.Object3D.Line()
            // self.line3D.transparent = true
           // self.line3D.color = 'blue'; 
            self.line3D.borderWidth  = 20
            self.line3D.width  = 20

            let geometry = self.line3D.geometry
            for (var i = 0; i < data.length; i++) {
                let origin = self.myMap.lngLatToGeodeticCoord([
                    data[i].longitude,
                    data[i].latitude,
                ])

                geometry.vertices.push(origin.x, origin.y, 0)
                geometry.vertexColors.push(0, 0, 0.6, 1)
                // geometry.strokeWeight: 5,
                let lineDe = {}
                if (i == 0) {
                    lineDe = data[0]
                } else {
                    let b = i - 1
                    lineDe = data[b]
                }
                // console.log(lineDe,'我选择的点')
                let des = self.myMap.lngLatToGeodeticCoord([
                    lineDe.longitude,
                    lineDe.latitude,
                ])
                geometry.vertices.push(des.x, des.y, 0)
                geometry.vertexColors.push(0, 0, 0.6, 1)
            }

            self.object3Dlayer.add(self.line3D)
            // console.log("我行走了轨迹")
        },
        // 打点
        potintMap(longitude, latitude) {
            const self = this
            try {
                self.myMap.remove(self.marker)
            } catch (err) {
                console.log(err)
            }
             const icon = new AMap.Icon({
                image: require('@/assets/img/map/qidian.png'), // 图片URL
                size: new AMap.Size(25, 34),  // 图标大小（宽，高）
                imageSize: new AMap.Size(25, 34) // 图片实际大小
            });
            self.marker = new AMap.Marker({
                icon: icon,
                position: [longitude, latitude],
            })
            self.myMap.add(self.marker)
            self.myMap.setFitView()
        },

        // 画区域
        getPolygon() {
            return new Promise((resolve, reject) => {
                const self = this
                let polygonArr = []
                resolve(self.polygon)
                // console.log(self.polygon)
                self.polygon.forEach((e) => {
                    polygonArr.push(e.split(":"))
                })
                // polygon.forEach((e) => {
                //     polygonArr.push(e.split(":"))
                // })
                var polygons = new AMap.Polygon({
                    map: self.myMap,
                    path: polygonArr, //设置多边形边界路径
                    strokeColor: "#2785dc", //线颜色
                    strokeOpacity: 0.2, //线透明度
                    strokeWeight: 3, //线宽
                    fillColor: "#2785dc", //填充色
                    fillOpacity: 0.35, //填充透明度
                })
                // polygon = polygons
                // this.polygon = polygons
            })
        },
    },
}
</script>
<style>
.loc-1 ::v-deep.el-input__inner{
   border: 1px solid #DCDFE6; 
}
</style>
<style lang="less" scoped>

.loc-1 {
    width: 98%;
    margin-left: 2%;
}
.topFlex {
    display: flex;
    .topLeft {
        flex: 1;
    }
    .topRight {
        margin-bottom: 20px;
        .ml20 {
            margin-left: 20px;
        }
    }
}
.tabBox {
    width: 400px;
    height: 130px;
    position: absolute;
    right: 0px;
    top: 0px;
    background: #fff;
    z-index: 2000;
}
</style>
